import React, { useState, useEffect } from "react";
import { ColorLens, CheckOutlined } from "@mui/icons-material";
import { Modal, Typography, Button } from "antd";
import "./ColorModalCoParent.css";

const { Title } = Typography;

const ColorsModal = ({ visible, onCancel, onSave, metaData, initialValues }) => {
  const [selectedColorId, setSelectedColorId] = useState(null);

  // Build color list with "No Color"
  const sortedMetaData = React.useMemo(() => {
    if (!metaData) return [];
    const noColorObj = { id: null, label_name: "No Color", value: null }; // 👈 id is null
    const hasNoColor = metaData.some(
      (c) => c.label_name === "No Color" && c.value === null
    );
    const others = metaData.filter(
      (c) => !(c.label_name === "No Color" && c.value === null)
    );
    return hasNoColor ? [...others, noColorObj] : [...others, noColorObj];
  }, [metaData]);

  useEffect(() => {
  if (visible && metaData?.length > 0) {
    if (initialValues?.id) {
      setSelectedColorId(initialValues.id);
    } else {
      const defaultSelected = metaData.find((c) => c.selected);
      setSelectedColorId(defaultSelected?.id || null);
    }
  }
}, [visible, metaData, initialValues]);


  const handleColorSelection = (id) => {
    setSelectedColorId(id);
  };

  const handleSave = () => {
    const selectedColor = sortedMetaData.find(
      (c) => c.id === selectedColorId
    ) || { id: null };

    // 👇 Force null if "No Color" is selected
    onSave({
      ...selectedColor,
      id: selectedColor.id ?? null,
      color_id: selectedColor.id ?? null,
    });
  };

  return (
    <Modal
      title={
        <Title level={4}>
          <ColorLens style={{ maxWidth: 22, marginRight: 10 }} />
          Color
        </Title>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={480}
    >
      <p>Pick a color</p>
      <div
        className="color-options"
        style={{ display: "flex", flexWrap: "wrap", gap: 12 }}
      >
        {sortedMetaData?.map((color) => (
          <div
            key={color.id ?? "no-color"}
            className={`color-circle ${
              selectedColorId === color.id ? "selected" : ""
            }`}
            style={{
              backgroundColor: color.value || "#fff",
              width: 32,
              height: 32,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              border: color.id === null ? "1px dashed #aaa" : "1px solid #ccc",
              position: "relative",
            }}
            onClick={() => handleColorSelection(color.id)}
          >
            {color.id === null ? (
              <span
                style={{
                  color: "#aaa",
                  fontSize: 10,
                  fontWeight: 600,
                  textAlign: "center",
                  userSelect: "none",
                }}
              >
                No
                <br />
                Color
              </span>
            ) : null}
            {selectedColorId === color.id && (
              <CheckOutlined
                style={{
                  color: color.id === null ? "#1890ff" : "#fff",
                  fontSize: 14,
                  position: "absolute",
                }}
              />
            )}
          </div>
        ))}
      </div>

      <div style={{ textAlign: "right", marginTop: 32 }}>
        <Button onClick={onCancel} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={handleSave}
          disabled={selectedColorId === undefined}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default ColorsModal;
